import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    section: {
      marginTop: 20,
      borderBottomWidth: 1,
    },
    sectionTitle: {
      fontSize: 12,
      fontWeight: '600',
      paddingHorizontal: 20,
      paddingTop: 15,
      paddingBottom: 10,
      letterSpacing: 1,
    },
    settingItem: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 20,
      paddingVertical: 16,
      borderBottomWidth: 1,
    },
    settingLeft: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    settingIcon: {
      width: 40,
      marginRight: 10,
    },
    settingTitle: {
      fontSize: 16,
      fontWeight: '500',
      marginBottom: 2,
    },
    settingDescription: {
      fontSize: 14,
    },
    modalOverlay: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 20,
    },
    modalContent: {
      width: '100%',
      maxWidth: 340,
      borderRadius: 16,
      overflow: 'hidden',
    },
    modalTitle: {
      fontSize: 18,
      fontWeight: '600',
      textAlign: 'center',
      paddingVertical: 20,
    },
    languageOption: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 20,
      paddingVertical: 16,
      borderBottomWidth: 1,
    },
    languageName: {
      fontSize: 16,
      fontWeight: '500',
      marginBottom: 2,
    },
    languageNameSecondary: {
      fontSize: 14,
    },
    modalCancel: {
      paddingVertical: 16,
      alignItems: 'center',
      borderTopWidth: 1,
    },
    modalCancelText: {
      fontSize: 16,
      fontWeight: '600',
    },
  });
